import React from 'react';

import { useRowTabIndex } from 'flow/components/ui-components/row-tab-stop';
import SectionTitle from './SectionTitle';

interface Props {
    sectionId: string;
    title: string;
    isOpen: boolean;
    canToggle: boolean;
    onToggle: (sectionId: string, isOpen: boolean) => void;
}

const FoldableSectionTitle = ({
    sectionId,
    title,
    isOpen,
    canToggle,
    onToggle,
}: Props) => {
    const rowTabIndex = useRowTabIndex();

    return canToggle ? (
        <button
            type="button"
            aria-expanded={isOpen}
            onClick={() => onToggle(sectionId, isOpen)}
            tabIndex={rowTabIndex}
            className="focus-ring-inset flex w-full cursor-pointer rounded-sm text-start hover:bg-gray-200"
        >
            <SectionTitle showOpen={isOpen} showIcon={true}>
                {title}
            </SectionTitle>
        </button>
    ) : (
        <SectionTitle showOpen={isOpen} showIcon={false}>
            {title}
        </SectionTitle>
    );
};

export default FoldableSectionTitle;
